<template>
  <hi-page>
    <hi-page-column card width="25vw">
      <template v-slot:header>
        <hi-row flex>
          <div class="flex-grow-1">SMS Campaigns</div>
          <new-sms-campaign></new-sms-campaign>
        </hi-row>
      </template>
      <sms-campaign-list @select="selectCampaign"></sms-campaign-list>
      <template v-slot:footer>Footer</template>
    </hi-page-column>
    <router-view></router-view>
  </hi-page>
</template>
<script>
import HiPage from "@/components/scaffold/HiPage";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import HiRow from "@/components/scaffold/HiRow";
// import Validator from "@/hive/Validator";
// import { api } from "@/api";
// import Formatter from "@/hive/Formatter";
// import HiList from "@/components/HiList";
// import SmsEditor from "@/components/sms/SmsEditor";
// import SmsScheduler from "@/components/sms/SmsScheduler";
import NewSmsCampaign from "@/components/sms/NewSmsCampaign";
import SmsCampaignList from "@/components/sms/SmsCampaignList";
// import SMS_Campaign from "@/pages/SMS_Campaign";

export default {
  name: "Leads",
  components: {
    // SMS_Campaign,
    SmsCampaignList,
    NewSmsCampaign,
    // SmsScheduler,
    // SmsEditor,
    // HiList,
    HiRow,
    HiPageColumn,
    HiPage
    // LeadDetails,
    // LeadComments
  },
  data() {
    return {
      smsText: null
    };
  },
  methods: {
    selectCampaign(campaign) {
      this.$router.replace({ path: `/sms/${campaign.id}` });
    }
  },
  created() {},
  destroyed() {}
};
</script>
<style></style>
